import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

@Component({
  selector: 'ui-daterange',
  templateUrl: './daterange.component.html',
  standalone: false
})
export class UiDaterangeComponent implements OnInit {
  @Input() startDate = '';
  @Input() endDate = '';
  /**
   * Which preset shows as selected.
   *
   * An input so a caller that persists its filter can restore the highlighted
   * button, not only the dates. Without it this always reset to 3M on reopen,
   * so the dates could say one month while the 3M button looked chosen.
   */
  @Input() activePreset = '3M';
  @Output() rangeChange = new EventEmitter<{ start: string; end: string; preset: string }>();

  presets = ['1M', '3M', '6M', 'Custom'];

  ngOnInit(): void {
    if (!this.startDate || !this.endDate) {
      this.applyPreset('3M');
    }
  }

  applyPreset(preset: string): void {
    this.activePreset = preset;
    // Custom keeps whatever dates are already chosen, but the caller still needs
    // to hear about it or it would persist the previous preset.
    if (preset === 'Custom') {
      this.emitRange();
      return;
    }
    const end = new Date();
    const start = new Date();
    const months = preset === '1M' ? 1 : preset === '3M' ? 3 : 6;
    start.setMonth(start.getMonth() - months);
    this.startDate = this.formatDate(start);
    this.endDate = this.formatDate(end);
    this.emitRange();
  }

  onStartChange(date: string): void {
    this.startDate = date;
    // Editing a date by hand is a custom range, whatever was selected before.
    this.activePreset = 'Custom';
    this.emitRange();
  }

  onEndChange(date: string): void {
    this.endDate = date;
    this.activePreset = 'Custom';
    this.emitRange();
  }

  private emitRange(): void {
    if (!this.startDate || !this.endDate) { return; }
    this.rangeChange.emit({ start: this.startDate, end: this.endDate, preset: this.activePreset });
  }

  private formatDate(d: Date): string {
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  }
}
